
















































import { Component, Vue } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { getMarkers, getSuggestions } from '../api/index'
import icons from '../config/icons'
import isMobile from '../utils/isMobile'
// @ts-ignore
import AMap from 'AMap'

@Component
export default class Map extends Vue {
  @State zoom!: number
  @State northeast!: number
  @State southwest!: number
  @State mapStatus!: number
  @Mutation updateMapState!: Function
  @Mutation updateMapStatus!: Function

  private timer: any = null
  private map: any = null
  private markers: any[] = [] // 坐标点数组
  private groups: any[] = [] // 群标记视图数据
  private clusters: any[] = [] // 聚合视图数据
  private cluster: any = null // 聚合视图
  private searchMarker: any = null
  private infoWindow: any = new AMap.InfoWindow({
    offset: new AMap.Pixel(0, -20)
  })
  private points: any[] = [] // 点标记视图数据
  private circle: any = null // 范围视图

  private suggestions: any[] = []
  private searchValue: string = ''

  private isMobile: boolean = false

  private async mounted () {
    this.init()
    this.renderMarkers()
  }
  // 初始化地图
  private init () {
    const mapOptions = {
      resizeEnable: true, // 是否可缩放
      zoom: this.zoom, // 默认缩放等级
      center: [116.405285, 39.904989], // 默认地图中心坐标
      features: ['bg', 'road', 'building'] // 默认地图显示要素
    }
    this.map = new AMap.Map('container', mapOptions) // 地图初始化

    this.renderToolBar() // 添加地图工具条
    this.renderMapState() // 监听地图可视范围、缩放等级
    this.bindMapEvents() // 地图事件绑定

    this.isMobile = isMobile()
  }
  private renderToolBar () {
    const toolBar = new AMap.ToolBar({ visible: true })
    this.map.addControl(toolBar)
  }
  private bindMapEvents () {
    this.map.on('zoomend', () => {
      console.log('zoomend')
      this.renderMapState()
      this.debounce()
    })
    this.map.on('moveend', () => {
      console.log('moveend')
      this.renderMapState()
      this.debounce()
    })
  }
  // 防抖
  private debounce () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => {
      this.renderMarkers()
    }, 500)
  }
  // 更新地图状态信息
  private renderMapState () {
    const zoom = this.map.getZoom()
    const { northeast, southwest } = this.map.getBounds()
    this.updateMapState({ zoom, northeast, southwest })
  }
  // 渲染标注
  private async renderMarkers () {
    if (this.cluster) {
      this.cluster.clearMarkers()
    }
    const bounds = this.map.getBounds()
    const options = {
      lbc: bounds.southwest.toString(),
      rtc: bounds.northeast.toString(),
      level: this.map.getZoom()
    }
    const data = await getMarkers(options)
    const { markers, point_type: pointType } = data

    this.updateMapStatus(pointType)
    this.markers = markers.map((marker: any) => {
      const type: string = marker.type === 'learn-organize' ? 'learn' : marker.type
      return {
        ...marker,
        lng: marker.lnglat[0],
        lat: marker.lnglat[1],
        type
      }
    })

    if (this.mapStatus === 1) {
      this.renderGroups()
    } else if (this.mapStatus === 2) {
      this.renderClusters()
    } else if (this.mapStatus === 3) {
      this.renderPoints()
    }

    if (this.searchMarker) {
      this.map.add(this.searchMarker)
    }
  }
  private renderGroups () {
    if (this.cluster) {
      this.cluster.clearMarkers()
    }
    this.groups = this.markers.map((marker: any) => {
      const content = `<div class="group">
        <div class="group-name">${marker.name}</div>
        <div class="group-title">${marker.title}</div>
      </div>`
      const group = new AMap.Marker({
        position: new AMap.LngLat(marker.lng, marker.lat),
        title: marker.name,
        content
      })

      AMap.event.addListener(group, 'click', (e: any) => {
        this.map.setZoomAndCenter(13, [marker.lng, marker.lat])
      })
      AMap.event.addListener(group, 'mouseover', (e: any) => {
        group.setzIndex(200)
      })
      group.on('mouseout', (e: any) => {
        group.setzIndex(100)
      })

      return group
    })
    this.map.clearMap()
    this.map.add(this.groups)
  }
  private renderClusters () {
    // this.map.clearMap()
    // this.groups = []
    if (this.cluster) {
      this.cluster.setMap(this.map)
    }

    this.clusters = this.markers.map((marker: any) => {
      const cluster = new AMap.Marker({
        position: new AMap.LngLat(marker.lng, marker.lat),
        icon: icons.school
      })

      cluster.title = marker.title
      AMap.event.addListener(cluster, 'click', (e: any) => {
        this.infoWindow.setContent(`<div>${cluster.title}</div>`)
        this.infoWindow.open(this.map, e.lnglat)
      })

      return cluster
    })
    this.map.clearMap()
    this.cluster = new AMap.MarkerClusterer(this.map, this.clusters, {
      gridSize: 100
    })
  }
  private renderPoints () {
    // todo 是否清空?
    this.cluster.clearMarkers()
    this.points = this.markers.map((marker: any) => {
      const point = new AMap.Marker({
        position: new AMap.LngLat(marker.lng, marker.lat),
        icon: icons[marker.type]
      })

      point.title = marker.title
      AMap.event.addListener(point, 'click', (e: any) => {
        this.infoWindow.setContent(`<div>${point.title}</div>`)
        this.infoWindow.open(this.map, e.lnglat)

        if (this.circle) {
          this.map.remove(this.circle)
          this.circle = null
        }

        this.circle = new AMap.Circle({
          center: new AMap.LngLat(marker.lng, marker.lat),
          radius: this.zoom >= 16 ? 500 : 1000,
          strokeColor: '#ff3333',
          strokeOpacity: 0.9,
          strokeWeight: 1,
          fillColor: '#ee2200',
          fillOpacity: 0.35
        })
        this.map.add(this.circle)
      })

      return point
    })

    this.map.clearMap()
    this.map.add(this.points)
  }
  async onSearchByKeywords (value: string) {
    const options = {
      keywords: value
    }
    const res = await getSuggestions(options)
    if (res.success) {
      this.suggestions = res.results
    }
  }
  onSearchByPoint (value: string) {
    if (this.searchMarker) {
      this.map.remove(this.searchMarker)
      this.searchMarker = null
    }
    const position: string[] = value.split(',')
    this.map.setCenter([position[0], position[1]])
    this.searchMarker = new AMap.Marker({
      position: new AMap.LngLat(position[0], position[1]),
      icon: icons.basic,
      offset: new AMap.Pixel(-13, -30)
    })
    this.searchMarker.on('click', (e: any) => {
      const zoom = this.zoom >= 13 ? this.zoom : 13
      this.map.setZoomAndCenter(zoom);
    })
    this.map.add(this.searchMarker)
  }
  private getLocation (location: any) {
    if (this.searchMarker) {
      this.map.remove(this.searchMarker)
      this.searchMarker = null
    }
    const position: string[] = location.split(',')
    this.map.setCenter([position[0], position[1]])
    this.searchMarker = new AMap.Marker({
      position: new AMap.LngLat(position[0], position[1]),
      icon: icons.basic,
      offset: new AMap.Pixel(-13, -30)
    })
    this.searchMarker.on('click', (e: any) => {
      const zoom = this.zoom >= 13 ? this.zoom : 13
      this.map.setZoomAndCenter(zoom);
    })
    this.map.add(this.searchMarker)
  }
  private clearSuggestions () {
    this.suggestions = []
    this.searchValue = ''
  }
}
